<div class="dashboard-page">
  <section class="page-header">
    <h1>Dashboard Overview</h1>
    <p>
      <span>Viewing data for <strong>{{ selectedCompanyName() }}</strong></span>
    </p>

  </section>

  @if (isLoading) {
  <div class="empty-state">Loading dashboard...</div>
  } @else if (errorMessage) {
  <div class="empty-state error">{{ errorMessage }}</div>
  } @else if (dashboardData) {
  @if (dashboardData.startupCreditSummary) {
  <section class="credit-summary-row">
    <article class="stat-card credit-card-available">
      <div class="card-top">
        <span class="card-title">Available Credits</span>
        <span class="icon-badge icon-blue">✨</span>
      </div>
      <div class="credit-details">
        <div class="credit-item">
          <span class="credit-value text-positive">{{ dashboardData.startupCreditSummary.availableCredits }}</span>
          <span class="credit-helper">Automatically applied to new jobs before payment</span>
        </div>
      </div>
    </article>
    <article class="stat-card credit-card-used">
      <div class="card-top">
        <span class="card-title">Credit Used</span>
        <span class="icon-badge icon-indigo">💳</span>
      </div>
      <div class="credit-details">
        <div class="credit-item">
          <span class="credit-value">{{ dashboardData.startupCreditSummary.usedCredits }}</span>
          <span class="credit-helper">Deducted automatically at job creation</span>
        </div>
      </div>
    </article>
  </section>
  }

  <section class="stats-grid" [class.stats-grid--6]="dashboardData.overviewCards.length === 6"
    [class.stats-grid--5]="dashboardData.overviewCards.length === 5">
    @for (item of dashboardData.overviewCards; track item.title) {
    <article class="stat-card">
      <div class="card-top">
        <span class="card-title">{{ item.title }}</span>
        <span class="icon-badge" [ngClass]="item.iconClass">{{ item.icon }}</span>
      </div>
      <div class="card-value">
        {{ item.value }}
      </div>
    </article>
    }
  </section>

  <section class="section-block">
    <h2>{{ isSuperAdmin() ? 'Sales by Service' : 'Cost Breakdown' }}</h2>
    <div class="service-grid">
      @for (item of dashboardData.salesByService; track item.title) {
      <article class="service-card">
        <div class="card-top">
          <span class="card-title">{{ item.title }}</span>
          <span class="icon-badge" [ngClass]="item.iconClass">{{ item.icon }}</span>
        </div>
        <div class="service-value">{{ item.value }}</div>
      </article>
      }
    </div>
  </section>

  @if (isSuperAdmin()) {
  <section class="section-block">
    <h2>Cost Breakdown</h2>
    <div class="service-grid">
      @for (item of dashboardData.costBreakdown; track item.title) {
      <article class="service-card">
        <div class="card-top">
          <span class="card-title">{{ item.title }}</span>
          <span class="icon-badge" [ngClass]="item.iconClass">{{ item.icon }}</span>
        </div>
        <div class="service-value">{{ item.value }}</div>
      </article>
      }
    </div>
  </section>
  }
  @if (isSuperAdmin()) {
  <section class="section-block">
    <h2>Profit Breakdown</h2>
    <div class="service-grid">
      @for (item of dashboardData.profitBreakdown; track item.title) {
      <article class="service-card">
        <div class="card-top">
          <span class="card-title">{{ item.title }}</span>
          <span class="icon-badge" [ngClass]="item.iconClass">{{ item.icon }}</span>
        </div>
        <div class="service-value" [class.text-positive]="item.valueClass === 'text-positive'"
          [class.text-negative]="item.valueClass === 'text-negative'">
          {{ item.value }}
        </div>
      </article>
      }
    </div>
  </section>
  }
  }
</div>